import { render, staticRenderFns } from "./page-feedback-popup.vue?vue&type=template&id=0c5ca34e&scoped=true&"
import script from "./page-feedback-popup.vue?vue&type=script&lang=js&"
export * from "./page-feedback-popup.vue?vue&type=script&lang=js&"
import style0 from "./page-feedback-popup.vue?vue&type=style&index=0&id=0c5ca34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ca34e",
  null
  
)

component.options.__file = "page-feedback-popup.vue"
export default component.exports